import { render, staticRenderFns } from "./YuboyaProItem.vue?vue&type=template&id=415cd0a6&scoped=true&"
import script from "./YuboyaProItem.vue?vue&type=script&lang=ts&"
export * from "./YuboyaProItem.vue?vue&type=script&lang=ts&"
import style0 from "./YuboyaProItem.vue?vue&type=style&index=0&id=415cd0a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415cd0a6",
  null
  
)

export default component.exports